export function throttle(fn, wait, context) {
  let time = Date.now()
  return function () {
    if (time + wait - Date.now() < 0) {
      fn.apply(context || null, arguments)
      time = Date.now()
    }
  }
}
